import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MessagingService} from '../../../services/messaging.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FeeScheduleService} from '../services/fee-schedule.service';
import {dataPatientInsurance} from '../../ar/_models/ar.models';

@Component({
  selector: 'app-fee-schedule-update-profile',
  templateUrl: './fee-schedule-update-profile.component.html',
  styleUrls: ['./fee-schedule-update-profile.component.scss']
})
export class FeeScheduleUpdateProfileComponent implements OnInit {

  isLoading: boolean;
  insurancePatients: any[] = [];
  organizationID: string;
  feeScheduleID: string;
  TDOCID: string = localStorage.getItem('TDOCID');

  constructor(
    public dialogRef: MatDialogRef<FeeScheduleUpdateProfileComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private messagingService: MessagingService,
    private feeScheduleService: FeeScheduleService,
    private snackBar: MatSnackBar,
  ) {}

  async ngOnInit(): Promise<void> {
    this.isLoading = true;

    if (this.data && this.data.OrganizationID && this.data.FeeScheduleID) {
      this.organizationID = this.data.OrganizationID;
      this.feeScheduleID = this.data.FeeScheduleID;
    }
    // alert(this.organizationID);

    // get data
    const promises: any[] = [
      this.feeScheduleService.getUCRInsuranceForOrganization(this.organizationID, this.TDOCID).toPromise(),
    ];

    try {
      const results: any[] = await Promise.all(promises);
      this.insurancePatients = results[0];

      this.isLoading = false;
    } catch (err) {
      this.isLoading = false;
      this.showMessage('Something went wrong', 'Error');
    }
  }

  close(payload) {
    this.dialogRef.close(payload);
  }

  showMessage(type, message) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top',
      panelClass: ['snackbar-linebreaks']
    });
  }

  updateInsurance() {
    this.feeScheduleService.updateUCRInsurance(this.organizationID, this.TDOCID, this.feeScheduleID)
      .subscribe(response => {
          if (response) {
            this.showMessage('Insurance profiles updated', 'Success');
            this.close(true);
          }
        },
        err => {
          // show error
          this.showMessage('Problem updating insurance profiles', 'Error');
        });
  }
}
